var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveRangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.28563,
    height: 14.142,
    rx: 0.642817,
    transform: "matrix(-0.707199 -0.707014 0.707199 -0.707014 5.49878 15.8184)",
    fill: "#FF5722"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.28563,
    height: 14.142,
    rx: 0.642817,
    transform: "matrix(-0.707199 0.707014 -0.707199 -0.707014 15.4991 14.9082)",
    fill: "#FF5722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveRangeIcon);
export default __webpack_public_path__ + "static/media/remove-range-icon.6c74ad04f085bc30756bdf266e625db0.svg";
export { ForwardRef as ReactComponent };